'use client'

import { useMediaQuery } from '@mui/material';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import {Rfs__all} from "../../../../_refs/Rfs__all";
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
const MenuPopOver = dynamic(() => import('@/components/widgets/menu-popover/menu-popover'), { ssr: false });
const LanguagePopover = dynamic(() => import('@/components/widgets/language-popover'), { ssr: false });

export default function Header() {

    Rfs__all.header_auth();

    const is_mobile = useMediaQuery('(max-width:1024px)');
    const t = useTranslations('main.header_items');

    return <header
        role="heading"
        aria-level={1}
        className="flex flex-row items-center lg:h-[109px] pt-10 pb-4 gap-6 lg:px-20 px-4 justify-between lg:justify-start "
    >
        <Image
            url='/logo.svg'
            alt='logo'
            className='lg:w-48 w-[100px]'
        />
        {!is_mobile &&
            <>
                <Link key={'homepage'} href={'/home'}>{t('Homepage')}</Link>

                <Link key={'about us'} href={'/'}>{t('About Us')}</Link>

                <LanguagePopover />

            </>
        }

        {
            is_mobile &&
            <MenuPopOver />
        }
    </header>
}
